import React, { Fragment, useState, useEffect } from 'react';
import {
  Button,
  Modal,
  Form,
  Row,
  Col,
  Container,
} from '@themesberg/react-bootstrap';
import { post } from '../../../services/back.service';
import { FaCog } from 'react-icons/fa';

function ModalFormAuthInspect({
  inspectionSelect,
  callback,
  title,
  button_text,
  button_variant,
}) {
  const [show, setShow] = useState(false);
  const [infoForm, setForm] = useState({
    state: 'T',
    authorization_rejection_reason: '',
  });
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleForm = ({ target }) => {
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (target.name === 'state' && value === 'T') setForm({ ...infoForm, authorization_rejection_reason: '' });
    setForm({ ...infoForm, [target.name]: value });
  };

  const saveForm = async (e) => {
    e.preventDefault();
    let respo,
      variant = '',
      msg = '';

    const body = { ...infoForm };
    respo = await post('/peritaje/authorization/' + inspectionSelect.id, body);

    if (respo.success) {
      variant = 'success';
      msg = 'Peritaje modificado exitosamente';
    } else {
      variant = 'danger';
      msg = respo.message;
    }
    setForm({
      state: 'T',
      authorization_rejection_reason: '',
    });
    handleClose();
    callback(variant, msg);
  };

  useEffect(() => { }, []);

  return (
    <Fragment>
      <Button
        disabled={!(inspectionSelect.state === 'A' || inspectionSelect.state === 'AP')}
        variant={button_variant}
        onClick={() => handleShow(inspectionSelect.id)}
        title={button_text}>
        <FaCog />
      </Button>

      <Modal animation={false} fullscreen="sm-down" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Form onSubmit={(e) => saveForm(e)}>
              <Form.Label htmlFor="nombre">Autorizar</Form.Label>
              <Form.Select
                name="state"
                value={infoForm.state}
                onChange={(e) => handleForm(e)}
                required
              >
                <option value="T">Si</option>
                <option value="P">No</option>
              </Form.Select>

              {infoForm.state === 'P' && <Fragment><Form.Label htmlFor="nombre">Razon de rechazo</Form.Label>
                <Form.Control
                  name="authorization_rejection_reason"
                  value={infoForm.authorization_rejection_reason}
                  onChange={(e) => handleForm(e)}
                  type="text"
                  required
                /> </Fragment>}

              <Row className="text-center m-3">
                <Col>
                  <Button variant="secondary">Limpiar Formulario</Button>
                </Col>
                <Col>
                  <Button
                    type="submit"
                    variant="primary"
                  >
                    Guardar Informacion
                  </Button>
                </Col>
              </Row>
            </Form>
          </Container>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
}

export default ModalFormAuthInspect;
